import { useState } from 'react'
import { ChevronDown, ChevronRight } from 'lucide-react'
import { clsx } from 'clsx'

interface TaskGroupHeaderProps {
  label: string
  count: number
  color?: string
  defaultOpen?: boolean
  children: React.ReactNode
  viewMode?: 'compact' | 'standard' | 'card'
}

export function TaskGroupSection({
  label,
  count,
  color,
  defaultOpen = true,
  children,
  viewMode = 'standard',
}: TaskGroupHeaderProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen)

  return (
    <div>
      <div className="workspace-group-header sticky top-2 z-10 mb-2 px-2">
        <button
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          className="flex min-h-[44px] w-full items-center gap-2 rounded-xl px-1 text-sm font-semibold select-none focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500"
          aria-expanded={isOpen}
        >
        {isOpen ? (
          <ChevronDown className={clsx('w-4 h-4', color)} />
        ) : (
          <ChevronRight className={clsx('w-4 h-4', color)} />
        )}
        <span className={color}>{label}</span>
        <span
          className={clsx(
            'badge badge-sm',
            color?.includes('red') ? 'badge-danger' : 'badge-default',
          )}
        >
          {count}
        </span>
        </button>
      </div>

      {isOpen && (
        <div className={viewMode === 'card' ? 'space-y-3 sm:grid sm:grid-cols-2 sm:gap-4 sm:space-y-0' : 'space-y-2.5'}>
          {children}
        </div>
      )}
    </div>
  )
}

